import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = ({ isOpen, toggle }) => {
  const location = useLocation();

  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


            
        
  const menuItems=[
    
    {name:"Category",path:"/admin/category",icon:"fa fa-star"},
    {name:"Subcategory",path:"/admin/subcategory",icon:"fa fa-star"},
    {name:"Projects Category",path:"/admin/ProjectsCategory",icon:"fa fa-star"},
    {name:"Projects Subcategory",path:"/admin/enhanced_category",icon:"fa fa-star"},
    {name: "Photo Gallery", path: "/admin/photo-gallery", icon: "fa fa-star"},
    {name: "About Us", path: "/admin/about-us", icon: "fa fa-star"},
    {name: "Contact Us", path: "/admin/Contact_us", icon: "fa fa-star"},
    {name: "Testimonial", path: "/admin/testimonial", icon: "fa fa-star"},
    {name: "Latest Projects", path: "/admin/latest", icon: "fa fa-star"},
    {name: "Completed Projects", path: "/admin/completed", icon: "fa fa-star"},
    {name: "City Projects", path: "/admin/CityImage", icon: "fa fa-star"},
    {name: "Blogs", path: "/admin/blog", icon: "fa fa-star"},
    {name: "Slider Banner", path: "/admin/banner", icon: "fa fa-star"},
    {name: "Recent News", path: "/admin/recent_news", icon: "fa fa-star"},
    {name: "Question Answer", path: "/admin/qa", icon: "fa fa-star"},
    {name: "Low Budget Interior", path: "/admin/lowbudgetinetriorad", icon: "fa fa-star"},
    {name: "Affordable Cost Interior", path: "/admin/affordablecostadmin", icon: "fa fa-star"},
    {name: "Previous Work", path: "/admin/previouscost", icon: "fa fa-star"},
    {name: "Design Idea", path: "/admin/designideada", icon: "fa fa-star"},
    {name: "Chat Enquiry", path: "/admin/chat_ready", icon: "fa fa-star"},
    {name: "Budget Enquiry", path: "/admin/budget_query", icon: "fa fa-star"},   
    {name: "Kitchen Related Calculator", path: "/admin/kitchen_calculator", icon: "fa fa-star"},  
    {name: "Kitchen Shape Realted Calculator", path: "/admin/kitchen_dropdown", icon: "fa fa-star"},          
    {name: "Reference", path: "/admin/referearnadmin", icon: "fa fa-star"},    
    {name: "Kitchen calculator", path: "/admin/kichencalcshow", icon: "fa fa-star"},          


  ]

  const isActive = (path) => {
    if (path === "/admin") {
      return location.pathname === "/admin" || location.pathname === "/admin/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <div style={{ fontFamily: "Arial", flexShrink: 0 }}>
     
      {!isDesktop && isOpen && (
        <div
          onClick={toggle}
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 998,
          }}
        />
      )}

     
      <div
        style={{
          position: isDesktop ? "sticky" : "fixed",
          top: 0,
          left: isDesktop ? 0 : isOpen ? 0 : "-260px",
          width: "260px",
          height: "100vh",
          background: "#1e1e2d",
          color: "#fff",
          transition: "0.3s",
          zIndex: 999,
          paddingTop: "20px",
          overflowY: "auto",
          boxShadow: isDesktop ? "none" : "2px 0 5px rgba(0,0,0,0.5)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 15px",
            marginBottom: "20px",
          }}
        >
         

          {!isDesktop && (
            <button
              onClick={toggle}
              style={{
                background: "transparent",
                color: "#fff",
                border: "none",
                fontSize: "20px",
                cursor: "pointer",
              }}
            >
              ✕
            </button>
          )}
        </div>

        <div style={{ display: "flex", flexDirection: "column" }}>
         
          {menuItems.map((item,i)=>(
            <Link
              key={i}
              to={item.path}
              onClick={() => !isDesktop && toggle()}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "12px 15px",
                margin: "4px 10px",
                borderRadius: "6px",
                textDecoration: "none",
                color: isActive(item.path) ? "#fff" : "#aaa",
                background: isActive(item.path)
                  ? "linear-gradient(90deg,#ff416c,#ff4b2b)"
                  : "transparent",
                transition: "all 0.3s ease",
              }}
            >
              <i className={item.icon} style={{ marginRight: "10px", width: "20px", textAlign: "center" }} />
              {item.name}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;